import * as React from 'react';
import { decodeToken, getDeviceId, getEnv, getNovadeUrl, getRegion, trackGotoNovadeLiteEvent } from '../utils/utils';
import background from '../assets/nl_skyline.svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { isMobile } from 'react-device-detect';
import { useEffect } from 'react';
import { BrickAnimation } from '../components/BrickAnimation/BrickAnimation';
import { Profile } from '../components/types';

let hasInitRun = false;
const redirectTimeMs = 5000;

export const Success = () => {
  const params = useLocation();
  const novadeUrl = getNovadeUrl();
  const state = params.state as { profile?: Profile; apiUrl?: string } ?? {};
  const { profile, apiUrl } = state;
  const env = getEnv();
  const navigate = useNavigate();
 
  async function login(profile: Profile, apiUrl: string) {
    const region = getRegion(env, apiUrl);
    const { databaseID } = decodeToken(profile.token);
    const response = await fetch(`${apiUrl}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        email: profile.email,
        password: profile.password,
      }),
    });

    // We want the default url to be /login-redirect instead of empty string. NovadeLite will handle
    // the redirect query parameters especially the databaseID for proper redirect to the new workspace.
    const url = `${novadeUrl}/login-redirect?env=${env}&region=${region}&database-id=${databaseID}`;

    if (response.ok) {
      const data = await response.json();
      // Refresh token is stored in Cookie on web so we don't need to pass it as query parameter.
      return isMobile ? `${url}&refresh-token=${data.refreshToken}` : url;
    }

    return url;
  }

  async function init() {
    if (profile && apiUrl) {
      const deviceIDParams = getDeviceId(profile);
      trackGotoNovadeLiteEvent(profile); 
      const path = isMobile ? '/splash' : '';

      const autoLoginUrl = !profile.sso ? await login(profile, apiUrl) : '';

      const redirectUrl = profile.sso || autoLoginUrl === ''
        ? deviceIDParams ? `${novadeUrl}${path}?${deviceIDParams}` : `${novadeUrl}${path}`
        : deviceIDParams ? `${autoLoginUrl}&${deviceIDParams}` : autoLoginUrl;

      setTimeout(() => {
        if (isMobile) {
          window.open(redirectUrl);
        }
        window.location.replace(redirectUrl);
      }, redirectTimeMs);
    } else {
      // profile and apiUrl could be undefined if the user navigates to this page directly.
      // In this case, we redirect to the error page.
      navigate('/error', { replace: true });
    }
  }

  useEffect(() => {
    if (hasInitRun) return;
    hasInitRun = true;
    init();
  }, []);

  const backgroundStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'repeat-x',
    backgroundPosition: 'bottom',
    backgroundAttachment: 'fixed',
  };

  return <div className="App" style={backgroundStyle}>
    <div
      style={{
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      }}
    ><BrickAnimation messageKey='workspace_loading'/>
    </div>
  </div>;
};
